module.exports = __webpack_public_path__ + "img/404.ca797f2b.svg";